// Centralized defaults
export const DEFAULT_YEAR = 2024;

// Feature flags
// Toggle whether the Year dropdown in View #2 immediately applies on selection (true)
// or requires clicking the Go button to apply (false). Default: false per UX.
export const APPLY_YEAR_ON_SELECT_VIEW2 = false;
